
<span
  v-if="inline"
  class="ws-message inline"
  :class="type"
>
  <template v-if="hasMessages">
    <span
      v-for="(msg, index) in msgs"
      :key="texts[index] + index"
    >
      <span v-if="index">, </span>{{ texts[index] }}</span>
  </template>
  <template v-else>
    <slot></slot>
  </template>
</span>
<div
  v-else-if="hasMessages"
  class="ws-message"
  :class="{
    banner,
    prepend: $slots.prepend || icon,
    append: $slots.append || button,
    [type]: true,
  }"
>
  <template v-for="(msg, index) in msgs">
    <ws-state-banner
      v-if="banner"
      :key="texts[index] + index"
      v-bind="$attrs"
      :type="type"
    >
      <div
        v-if="$slots.prepend || iconResolved"
        class="prepend"
      >
        <slot name="prepend">
          <ws-icon
            :name="iconResolved"
            v-bind="iconAttrsResolved"
          />
        </slot>
      </div>
      <div class="content q-ml-md">
        <div
          v-if="$slots.title || texts[index]"
          class="title"
          :class="
            !$slots.title || descriptions[index]
              ? 'text-bold text-' + (featuresColor || 'bold')
              : ''
          "
        >
          <slot name="title">
            <small><span v-if="prepend">{{ $t(prepend) }} </span>{{ texts[index] }}</small>
          </slot>
        </div>
        <slot name="content">
          <small v-if="descriptions[index]">{{ descriptions[index] }}</small>
        </slot>
      </div>
      <div
        v-if="$slots.append || button"
        class="append q-ml-lg"
      >
        <slot name="append">
          <ws-button
            :class="{
              'default-button-margins': !get(
                buttonAttrs,
                'clearDefaultButtonMargins'
              ),
            }"
            v-bind="buttonAttrsResolved"
          >
            {{
              $t(button.translationKey || 'uikit:general.link', button.values)
            }}
          </ws-button>
        </slot>
      </div>
      <!-- TODO: Ask Peto Posa about this feature -->
      <!-- <template v-if="canClose">
          <ws-button
            flat
            color="ws-error"
            icon="close"
            @click="remove(index, msg)"
          />
        </template> -->
    </ws-state-banner>
    <q-banner
      v-else
      :key="texts[index] + index"
    >
      <span v-if="prepend">{{ $t(prepend) }} </span>{{ texts[index] }}
    </q-banner>
  </template>
</div>
<div
  v-else-if="$slots.default"
  class="ws-message"
  :class="{
    banner,
    inline,
    prepend: $slots.prepend || icon,
    append: $slots.append || button,
    [type]: true,
  }"
>
  <slot></slot>
</div>
